class AddToCartModalController {
    constructor($timeout, $window, cartService, service, price, currency, quantity, shop_id, model, close) {
        'ngInject';

        this.$window = $window;
        this.model = model;
        this.service = service;
        this.cartService = cartService;
        this.price = {
            net: price.net / quantity,
            gros: price.gros / quantity
        };
        this.currency = currency;
        this.fullPrice = price;
        this.quantity = quantity;
        this.shop_id = shop_id;
        this.closeCallback = close;
        this.loading = true;
        this.showPreview = false;
        this.showDownload = false;
        this.addedToCart = false;
        this.svg = {
            data: '',
            type: 'image/svg+xml'
        };

        $timeout(() => {
            this.showPreview = true;
        }, 500);

        $timeout(() => {
            this.showDownload = true;
        }, 1000);

        $timeout(() => {
            this.loading = false;
        }, 1500);
    }

    get isMobile() {
        return this.$window.innerWidth <= 720;
    }

    save() {
        console.log('configuratorController::addToCart');
        this.loading = true;

        this.service.addToCart(this.model, this.quantity, this.svg).then(
            response => {
                console.log('configuratorController::addToCart => success');

                this.cartService.load().then((response) => {
                    if (false && this.shop_id === 1) {
                        let itemNames = [];
                        let items = [];
                        angular.forEach(response.items, function(v, k) {
                            itemNames.push(v.name);

                            items.push({
                                "ProductID": "",
                                "SKU": "",
                                "ProductName": v.name,
                                "Quantity": v.quantity,
                                "ItemPrice": parseFloat(v.price_gros).toFixed(2),
                                "RowTotal": parseFloat(v.value_gros).toFixed(2),
                                "ProductURL": "//plasticexpress.pl/configurator/" + v.data.material.type.slug,
                                "ImageURL": "//plasticexpress.pl/assets/FE/img/configurator_custom_cart_item.png",
                                "ProductCategories": [
                                    v.data.material.type.name + (v.data.material.subType ? ', ' + v.data.material.subType.name : '') + ' ' + v.data.material.size.name
                                ]
                            });
                        });

                        _learnq.push(["track", "Added to Cart", {
                            "$value": parseFloat(response.summary_gros).toFixed(2),
                            "AddedItemProductName": this.model.name,
                            "AddedItemProductID": "",
                            "AddedItemSKU": "",
                            "AddedItemCategories": [
                                this.model.material.type.name + (this.model.material.subType ? ', ' + this.model.material.subType.name : '') + ' ' + this.model.material.size.name
                            ],
                            "AddedItemImageURL": "//plasticexpress.pl/assets/FE/img/configurator_custom_cart_item.png",
                            "AddedItemURL": "//plasticexpress.pl/configurator/" + this.model.material.type.slug,
                            "AddedItemPrice": parseFloat(this.price.gros).toFixed(2),
                            "AddedItemQuantity": this.quantity,
                            "ItemNames": itemNames,
                            "CheckoutURL": "//plasticexpress.pl/orders/checkout",
                            "Items": items
                        }]);
                    }
                });

                this.loading = false;
                this.addedToCart = true;
            },
            response => {
                this.loading = false;
                console.log(`Error while adding to cart!`);
            }
        );
    }

    goToCart() {
        window.location.pathname = 'cart';
    }

    updateSvg(svg) {
        console.log('configuratorController::updateSvg', svg);
        this.svg = svg;
    }

    close() {
        this.closeCallback(false, 200);
    }
}

export default AddToCartModalController;
